import { render } from "./BuyInput.vue?vue&type=template&id=25d003c4&scoped=true"
import script from "./BuyInput.vue?vue&type=script&lang=js"
export * from "./BuyInput.vue?vue&type=script&lang=js"

import "./BuyInput.vue?vue&type=style&index=0&id=25d003c4&scoped=true&lang=scss"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d003c4"]])

export default __exports__